// Google Analytics 4 helper.
// Reads REACT_APP_GA_MEASUREMENT_ID at runtime; no-ops if unset.

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";
let initialized = false;

export function initGA() {
  if (initialized || !GA_ID || typeof window === "undefined") return;

  // Inject gtag.js
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false }); // we send page_view manually on route change
  initialized = true;
}

export function trackPageView(path) {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.origin + path,
    page_title: document.title,
  });
}

export function trackEvent(name, params = {}) {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", name, params);
}

export const GA_ENABLED = Boolean(GA_ID);
